export const errorCodes = {
    USER_NOT_LOGGED_IN: "CODE_ERROR_APP:1-3",
}